import { Subject } from 'rxjs';
import { dailyMotionPlayerEventMap, PixelsVideoEvent } from '../../../constants/Video';

export const dailymotionPlayer$ = (player: DailyMotionPlayer, pageId: string) => {
  const sub = new Subject<[string, Record<string, any>]>();

  // for (const e of Object.values(window.dailymotion.events)) {
  //   player.on(e as string, (event: any) => {
  //     metricsLog(`>>> event is ${e}`, event)
  //   })
  // }
  for (const [key, value] of dailyMotionPlayerEventMap.entries()) {

    player.on(value, (event: any) => {
      switch (value) {
        case dailyMotionPlayerEventMap.get(PixelsVideoEvent.AD_ENDED): {
          // The way dailymotion send the skip event is different compare with jwplayer
          // we need to detect it here and forward the skipped event.
          if (event.adEndedReason === 'skipped') {
            sub.next([PixelsVideoEvent.AD_SKIPPED, event]);
          }
          sub.next([key, event]);
          break;
        }
        case dailyMotionPlayerEventMap.get(PixelsVideoEvent.VIDEO_BEFORE_PLAY):
        case dailyMotionPlayerEventMap.get(PixelsVideoEvent.FIRST_FRAME):
          sub.next([key, {
            pageId,
            videoId: event.videoId,
            videoDuration: event.videoDuration,
            integrationType: 'hero'
          }]);
          break;
        case dailyMotionPlayerEventMap.get(PixelsVideoEvent.AD_STARTED):
          sub.next([key, {
            duration: 0,
            position: 0,
            adPos: event.adPosition.replace(/roll$/, '')
          }]);
          break;
        case dailyMotionPlayerEventMap.get(PixelsVideoEvent.AD_TIME):
          sub.next([key, {
            duration: event.adDuration,
            position: event.adTime
          }]);
          break;
        case dailyMotionPlayerEventMap.get(PixelsVideoEvent.TIME):
          sub.next([key, {
            duration: event.videoDuration,
            position: event.videoTime
          }]);
          break;
        default:
          sub.next([key, event]);
      }
    });
  }
  return sub;
};